import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './shared/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  constructor(private http: HttpClient) { }

  public consumeBetaKey = async (key: string, email: string): Promise<boolean> => {
    const CONSUME_BETA_KEY_URL: string = `https://us-central1-relayclients.cloudfunctions.net/consumeBetaKey?email=${email}&key=${key}`;

    const consumeKeyReply: any = await this.http.get(CONSUME_BETA_KEY_URL).toPromise();
    console.log(consumeKeyReply);

    if (consumeKeyReply && consumeKeyReply.consumed) {
      return true;
    } else {
      return false;
    }
  }

  public createNamecheapUser = async (userId: string, body: object): Promise<any> => {
    const CREATE_NAMECHEAP_USER_URL: string = `https://us-central1-relayclients.cloudfunctions.net/createNamecheapUser?user=${userId}`;

    const createNamecheapUserReply: any = await this.http.post(CREATE_NAMECHEAP_USER_URL, body).toPromise();
    console.log(createNamecheapUserReply);
    return createNamecheapUserReply ? createNamecheapUserReply : {};

  };

  public checkBetaKey = async (key: string, email: string): Promise<boolean> => {
    const CHECK_KEY: string = `https://us-central1-relayclients.cloudfunctions.net/checkForValidKey?email=${email}&key=${key}`;

    const checkKeyReply: any = await this.http.get(CHECK_KEY).toPromise();
    console.log(checkKeyReply);

    if (checkKeyReply && checkKeyReply.valid) {
      return true;
    } else {
      return false;
    }
  }
}
